import type { ReactNode } from 'react';

import { useMediaQuery } from '../../../hooks/useMediaQuery';
import MinimalHeaderDesktop from './MinimalHeaderDesktop';
import MinimalHeaderMobile from './MinimalHeaderMobile';

interface MinimalHeaderProps {
  rightContent?: ReactNode;
  showLanguageSwitcher?: boolean;
  mobileVariant?: 'default' | 'compact';
}

const MinimalHeader = ({
  rightContent,
  showLanguageSwitcher = true,
  mobileVariant = 'default',
}: MinimalHeaderProps) => {
  const isDesktop = useMediaQuery('(min-width: 768px)');

  if (isDesktop) {
    return (
      <MinimalHeaderDesktop
        rightContent={rightContent}
        showLanguageSwitcher={showLanguageSwitcher}
      />
    );
  }

  return (
    <MinimalHeaderMobile
      rightContent={rightContent}
      showLanguageSwitcher={showLanguageSwitcher}
      variant={mobileVariant}
    />
  );
};

export default MinimalHeader;
